<template>
  <div class="no-gutters row">
    <div class="col-md">
      <Breadcrumb :items="breadcrumbItems" />
    </div>
    <div class="col-md-auto py-3">
      <ActionButtons
        v-if="actions.length"
        :buttons="actions"
      />
    </div>
  </div>

  <hr class="container-m-nx border-light my-0 mb-3" />
</template>

<script setup lang="ts">
import ActionButtons from "./ActionButtons.vue";
import Breadcrumb from "./Breadcrumb.vue";

defineProps({
  actions: { default: () => [], type: Array as () => any[] },
  breadcrumbItems: { required: true, type: Array as () => any[] },
});
</script>
